/* nl-video.js · Bewegtbild ohne Knopf.

   Zwei Rollen, dasselbe Gerüst:
   · [data-nl-cardvid] — Produktkachel. Rechner: darüberfahren (plus
     Tastatur-Fokus). Telefon: von selbst, sobald die Kachel zu zwei Dritteln
     im Bild steht — ein Tipp gehört dort dem Link zur Produktseite.
   · [data-nl-autovid] — ein Standbild, das sich bewegt (Marken-Sektion).
     Läuft überall von selbst, sobald es im Bild steht; Darüberfahren wäre hier
     die falsche Geste, weil es nichts zu entdecken gibt.
   Wer Bewegung abbestellt hat, bekommt in beiden Fällen nur das Standbild.

   Geladen wird nicht beim Seitenaufbau, aber auch nicht erst beim Anfassen:
   Beides war spürbar falsch. Beim Seitenaufbau zöge jede Kachel ihr Video,
   erst beim Darüberfahren beginnt der Download in dem Moment, in dem das Bild
   schon laufen soll — genau die Verzögerung, die auffällt. Deshalb wird
   vorgeladen, sobald etwas ins Bild kommt; das Darüberfahren drückt dann nur
   noch auf Start. */
(function () {
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SEL = '[data-nl-cardvid],[data-nl-autovid]';

  function vid(el) { return el.querySelector('video[data-nl-vsrc]'); }
  function auto(el) { return el.hasAttribute('data-nl-autovid'); }

  function warm(el) {
    var v = vid(el);
    if (!v || v.getAttribute('src')) return;
    v.setAttribute('preload', 'auto');
    v.setAttribute('src', v.dataset.nlVsrc || '');
    v.load();
  }

  /* Gemessener Fehler: kommt etwas in einem Sprung ins Bild (Ankerlink,
     scrollIntoView), meldet der Beobachter beide Schwellen in einem einzigen
     Eintrag. Dann setzt warm() gerade erst die Adresse und ruft load() — und
     das unmittelbar folgende play() bricht mit AbortError ab. Das ist kein
     Fehlschlag, sondern eine Reihenfolge: einmal nachfassen, sobald die ersten
     Daten da sind. Ohne das blieb die Marken-Animation beim Laden stehen. */
  function play(el) {
    var v = vid(el);
    if (!v || !el.classList.contains('is-playing')) return;
    var pr = v.play();
    if (pr && pr.catch) {
      pr.catch(function (err) {
        if (err && err.name === 'AbortError') {
          v.addEventListener('canplay', function () { play(el); }, { once: true });
        } else {
          stop(el);
        }
      });
    }
  }

  function start(el) {
    if (!vid(el)) return;
    warm(el);
    el.classList.add('is-playing');
    play(el);
  }

  function stop(el) {
    var v = vid(el);
    el.classList.remove('is-playing');
    if (!v) return;
    v.pause();
    try { v.currentTime = 0; } catch (e) {}
  }

  /* Ein einziger Beobachter für alles. Zwei Schwellen: die erste Berührung des
     Bildrands lädt vor, zwei Drittel Sichtbarkeit starten dort, wo von selbst
     gespielt wird. Pro Element ein eigener Beobachter wäre dieselbe Arbeit
     mal zwanzig. */
  var io = null;
  if (!calm && window.IntersectionObserver) {
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var e = entries[i], el = e.target;
        if (e.intersectionRatio > 0) warm(el);
        if (!fine || auto(el)) {
          if (e.intersectionRatio >= 0.6) { start(el); } else { stop(el); }
        }
      }
    }, { threshold: [0, 0.6] });
  }

  function bind(el) {
    if (el.dataset.nlVbound) return;
    el.dataset.nlVbound = '1';

    if (fine && !calm && !auto(el)) {
      el.addEventListener('mouseenter', function () { start(el); });
      el.addEventListener('mouseleave', function () { stop(el); });
      el.addEventListener('focusin', function () { start(el); });
      el.addEventListener('focusout', function () { stop(el); });
    }
    if (io) io.observe(el);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = scope.querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) bind(list[i]);
  }

  scan();
  document.addEventListener('DOMContentLoaded', function () { scan(); });

  /* Die Raster tauschen ihren Inhalt beim Reiterwechsel per fetch aus —
     neue Kacheln müssen dieselbe Geste bekommen wie die alten. */
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches(SEL)) bind(n);
          scan(n);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
